import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "reactstrap";
import { SessionsService } from "../../globals/services/sessions.service";
import moment from "moment";
import { UsersService } from "../../globals/services/users.service";
import msgIcon from "../../assets/images/msgIcon.svg";
import saveIcon from "../../assets/images/save-outline-icon.svg";
import SessionForm from "./components/SessionForm";
import styles from "./sessions.module.scss";
import Loader from "react-js-loader";

const Sessions = (props) => {
  const { item } = props.location.state;

  const history = useHistory();
  const usersService = UsersService();

  const initialState = {
    _id: item._id,
    sfSessionId: item.sessionId,
    sessionName: item?.sessionName || "",
    sessionTitle: item?.sessionTitle || "",
    startDate: item.startDate ? moment(item.startDate, "MM/DD/YYYY").format("YYYY-MM-DD") : "",
    language: item?.language || "",
    format: item?.classFormat || "",
    room: item?.room || "",
    city: item?.address?.city ? item.address.city : "",
    country: item?.address?.country ? item.address.country : "",
    state: item?.address?.state ? item.address.state : "",
    street: item?.address?.street ? item.address.street : "",
    zip: item?.address?.zip ? item.address.zip : "",
    sessionDescription: item?.sessionDescription || "",
    startTime: item.startTime ? moment(item.startTime, ["h:mm A"]).format("HH:mm") : "",
    endTime: item.endTime ? moment(item.endTime, ["h:mm A"]).format("HH:mm") : "",
    zoomUrl: item?.zoomUrl || "",
    registrationURL: item?.registrationURL || "",
    related: item?.related ? item.related : [],
    team: item?.sessionTeam ? item.sessionTeam : [],
    participants: item?.participants ? item.participants : [],
    sessionType: item?.sessionType || "",
    sessionPrivacy: item?.sessionPrivacy || "",
    sessionStatus: item?.sessionStatus || "",
    eventId: item.eventId,
    classReminder: item?.classReminder || "",
  };

  const [state, setState] = useState(initialState);
  const [teamState, setTeamState] = useState([])
  const [itemChange, setItemChange] = useState(false);
  const [teamsChange, setTeamsChange] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isMounted, setIsMounted] = useState(true);

  useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
    };
  }, []);

  useEffect(() => {
    if (state?.team) {
      const updatedTeams = state?.team?.map(((team) => {
        const { Name__r } = team || {};
        const { FirstName, LastName, HN_UserId__c } = Name__r || {};
        const name = `${FirstName} ${LastName}`;
        return { name, id: HN_UserId__c, checked: true }
      }))
      if (isMounted) {
        setTeamState(updatedTeams)
      }
    }
  }, [state?.team, isMounted])

  useEffect(() => {
    window.scrollTo(0, 0);
    getUsersForSession();
  }, []);

  const getUsersForSession = async () => {
    const users = await usersService.getUsersBySessionId(state._id);
    if (isMounted) {
      setState(prevState => ({ ...prevState, participants: users }));
    }
  };

  const handleRelatedChange = (related) => {
    setItemChange(true);
    setState(prevState => ({ ...prevState, related }));
  };

  const saveSessionChanges = async () => {
    if (!isMounted) return;
    
    setIsLoading(true);
    try {
      moment(item.startTime, ["h:mm A"]).format("HH:mm");

      if (teamsChange) {
        await UsersService().updateFaculty(teamState, state.team, state._id);
      }

      await SessionsService().updateSession(state);
      if (isMounted) {
        history.push(`/CurrentEventEditForm/${state.eventId}`, { updateEvent: true });
      }
    } catch (error) {
      console.error("Error save session changes", error);
    } finally {
      if (isMounted) {
        setIsLoading(false);
      }
    }
  };

  const handleForm = (prop) => {
    setItemChange(true);
    setState({
      ...state,
      ...prop,
    });
  };

  const handleFacultyForm = (changedUser) => {
    setItemChange(true);
    setTeamsChange(true);
    setTeamState(changedUser)
  };

  const goToNotification = () => {
    history.push({
      pathname: "/notification",
      state: { item: state },
    });
  };

  return (
    <div className={`${styles.container} container`}>
      {isLoading &&
        <div className={styles.loaderContainer}>
          <Loader type="spinner-circle"
            bgColor="#001f4c"
            title="save session changes, please wait..."
            color="#001f4c"
            size={50}
          />
        </div>
      }
      <SessionForm
        sessionData={state}
        teamState={teamState}
        handleForm={handleForm}
        handleFacultyForm={handleFacultyForm}
        handleRelatedChange={handleRelatedChange}
        getUsersForSession={getUsersForSession}
      />
      <div className="row">
        {itemChange && (
          <div className="float-right">
            <Button onClick={() => saveSessionChanges()} className="mx-2 saveBotton">
              <img src={saveIcon} alt="save icon" />
            </Button>
          </div>
        )}
        <div className="msgDialogBtn">
          <button className="msgDialogBtn" onClick={goToNotification}>
            <img src={msgIcon} alt="msg icon" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sessions;